import React from "react";
import CustomTooltip from "./CustomTooltip";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import { MuiIcons } from "../../../utils";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
    margin: {
        margin: theme.spacing(1)
    },
    extendedIcon: {
        marginRight: theme.spacing(1)
    }
}));

export const MuiIconButton = ({ color, className, size, onClick, title, icon, ...props }) => {
    const classes = useStyles();
    const baseClass = clsx(classes.margin, className);
    return (
        <React.Fragment>
            <CustomTooltip title={title}>
                <IconButton
                    aria-label="actionButton"
                    className={baseClass}
                    size={size}
                    onClick={onClick}
                    color={color}
                    style={{ outline: "none" }}
                    {...props}
                >
                    {MuiIcons[icon]}
                </IconButton>
            </CustomTooltip>
        </React.Fragment>
    );
};

MuiIconButton.defaultProps = {
    icon: "add",
    size: "small",
    color: "primary",
    className: ""
};

export default MuiIconButton;

// style={{outline:'none',backgroundColor:'rgb(29, 233, 182)',color:'#fff',marginRight:'15px'}}
